import { Component, OnInit, Input } from '@angular/core';
import { DownloadService } from '../../services/download/download.service';
import { saveAs } from 'file-saver/FileSaver';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';

@Component({
  selector: 'app-download-multiple-documents',
  templateUrl: './download-multiple-documents.component.html',
  styleUrls: ['./download-multiple-documents.component.css']
})

export class DownloadMultipleDocumentsComponent implements OnInit {
  @Input() fileName: any[];
  @Input() filePath: any[];
  @Input() uploadedFileName;
  @Input() isW9Form: string = 'false';
  filesDataList: any[];
  signedUrl;
  firstName;
  lastName;
  vendorName;
  role;
  errorMsg:boolean = false;
  agentId:any;
  constructor(private downloadService: DownloadService, private googleAnalyticsService:GoogleAnalyticsService) { }

  ngOnInit() {
    var fileList = [];
    for (var k=0; k < this.filePath.length; k++) {
      var singleFileObj = {};
      singleFileObj['fileName'] = this.fileName[k];
      singleFileObj['filePath'] = this.filePath[k];
      fileList.push(singleFileObj);
    }
    this.filesDataList = fileList;
    this.firstName = localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
    this.vendorName = localStorage.getItem('AgentName');
    this.role = localStorage.getItem("Role");
    this.agentId = localStorage.getItem("AgentId");
  }

  downloadDocument(fileName){
    this.role = localStorage.getItem("Role");
    if (this.isW9Form !== 'true' || this.role !== "PC Client") {
      let body = {
        "filePath": fileName.filePath,
        "vendor_id":this.agentId
      }

      this.downloadService.getDownloadSignedURL(body).subscribe((res) => {
       
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Downloaded a" + ' ' + this.uploadedFileName + ' ' + 'Document', this.vendorName, 10);
        this.signedUrl = res.Info;
        window.open(this.signedUrl, "_blank");
      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/components/download-multiple-documents/download-multiple-documents.component.ts